// Check if any vehicle is available after calling estimation EP
export const isUberVehicleAvailable = (uberVehicle: any): boolean => {
  return uberVehicle?.find((vehicle: any) => vehicle.product_id !== null);
};
